import { useMutation } from '@tanstack/react-query';
import apiClient from '../lib/api-client';
import { notifyUser } from '../util/util';

export function useTrackFutureValue() {
  return useMutation({
    mutationFn: async ({ inputs, result }) => {
      const formData = new FormData();
      inputs.forEach((input) => formData.append('inputs[]', input));
      formData.append('result', result);

      const response = await apiClient.post('track/future-value-calc', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Error');
      }

      return response.data;
    },
    onSuccess: (data) => {
      notifyUser('success', 'Future value calculated and tracked successfully.', 'Success');
    },
    onError: (error) => {
      if (error.response?.data?.data?.result) {
        error.response.data.data.result.forEach((err) => {
          notifyUser('error', err, 'Validation Error');
        });
      } else {
        const message = error?.response?.data?.message || error?.message || 'Failed to calculate future value.';
        notifyUser('error', message, 'Error');
      }
    },
  });
}